
import FolderMinus from "../../../assets/duotone/FolderMinus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FolderMinusIcon({ className, dataTestid = "FolderMinusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FolderMinus data-testid={dataTestid} className={classes} {...rest} />
  );
}
